import { render, staticRenderFns } from "./component-info-youtube.vue?vue&type=template&id=7f018541&scoped=true"
import script from "./component-info-youtube.vue?vue&type=script&lang=js"
export * from "./component-info-youtube.vue?vue&type=script&lang=js"
import style0 from "./component-info-youtube.vue?vue&type=style&index=0&id=7f018541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f018541",
  null
  
)

export default component.exports